// The two plans, in one place (2026-11-01): every ask on the site reads
// these, so the numbers and the words can't drift. STORY_LIMITS is what
// services/access/reader-access enforces; limits are off unless
// NEXT_PUBLIC_STORY_LIMITS_ENABLED is on (a change needs a redeploy).
export const STORY_LIMITS = { guest: 5, free: 10 }

export function limitsOn() {
  return process.env.NEXT_PUBLIC_STORY_LIMITS_ENABLED === 'true'
}

export const UNLIMITED_PRICE = '$5 a month'

export const PLANS = {
  free: {
    name: 'Free',
    price: '$0',
    points: [
      'The daily newsletter, every morning',
      `${STORY_LIMITS.free} stories a month on the site`,
    ],
  },
  unlimited: {
    name: 'Unlimited',
    price: UNLIMITED_PRICE,
    points: [
      'Every story on the site, unlimited',
      'The daily newsletter, every morning',
      'Keeps Pano reader-funded, with no ads',
    ],
  },
}

// The free signup's one line: the newsletter, plus the stories that make
// signing up worth it on the site (only while limits are on).
export function freePitch() {
  return limitsOn()
    ? `The daily newsletter, plus ${STORY_LIMITS.free} free stories a month on the site.`
    : 'The day’s biggest stories and how each side covered them. Free.'
}
